export const globalQueryKeys = {
  clients: ['clients'] as const,
  districts: ['districts'] as const,
  states: ['states'] as const,
  tags: ['tags'] as const,
} as const;
